import {defineStore} from "pinia";

export const useDeclarationCotisationStore = defineStore('declarationCotisation', {
    state: () => ({
        declarationCotisation: {},
        declarationCotisations: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setDeclarationCotisation(declarationCotisation) {
            this.declarationCotisation = declarationCotisation
        },
        setDeclarationCotisations(declarationCotisations) {
            this.declarationCotisations = declarationCotisations
        },
        addDeclarationCotisation(declarationCotisation) {
            this.declarationCotisations.unshift(declarationCotisation)
        },
        updateDeclarationCotisation(declarationCotisation) {
            let index = this.declarationCotisations.findIndex(cl => cl.id === declarationCotisation.id)
            this.declarationCotisations.splice(index, 1, declarationCotisation)
        },
        deleteDeclarationCotisation(declarationCotisation) {
            let index = this.declarationCotisations.findIndex(cl => cl.id === declarationCotisation.id)
            this.declarationCotisations.splice(index, 1)
        },
    },
});